// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3BCzV","boxImg":"Card_boxImg__2K4E5","flash":"Card_flash__q9_Pg","containerText":"Card_containerText__1-jPi","stars":"Card_stars__26S7D"};